<template>
  <div
    class="select-field w-full flex items-center"
    :class="{
      'select-field--error': hasError,
      'select-field--simple': isSimpleDesign,
      'select-field--focus': modelValue,
      'select-field--filled': filled
    }"
    :style="{ borderColor: borderColor }"
  >
    <label v-if="label" :for="id" class="block text-body mb-8">
      {{ label }}
    </label>
    <template v-if="iconClassLeft">
      <div
        :class="[iconClassLeft]"
        class="select-field__left-icon pl-16"
        @click="$emit('on-left-click')"
      ></div>
    </template>
    <div class="select-field__select-wrapper">
      <select
        :id="id"
        class="select-field__select px-16 cursor-pointer"
        :class="{
          'select-field__select--has-icon-left': iconClassLeft,
          'select-field__select--has-icon-right': iconClassRight
        }"
        :disabled="isDisabled"
        name=""
        :value="modelValue"
        data-testid="select"
        @input="selectValue"
        @change="$emit('change')"
      >
        <template v-if="placeholder">
          <option selected hidden disabled value="">
            {{ placeholder }}
          </option>
        </template>
        <template v-if="isOnlyObjectOptions">
          <option
            v-for="(option, index) in options"
            :key="`select-${index}`"
            :value="option[valuePropName]"
          >
            {{ option[titlePropName] }}
          </option>
        </template>
        <template v-else>
          <option
            v-for="option in options"
            :key="`select-${option}`"
            :value="option"
          >
            {{ option }}
          </option>
        </template>
      </select>
      <span
        class="text-md font-inter-regular select-field__icon select-field__icon--right hs-icon--chevron-down"
        :class="{ 'text-gray-3': isDisabled }"
      ></span>
    </div>
    <template v-if="iconClassRight">
      <div
        :class="[iconClassRight]"
        class="select-field__left-icon absolute right-16 pointer-events-none"
        @click="$emit('on-right-click')"
      ></div>
    </template>
  </div>
  <div v-if="hasError" class="select-field__msg mt-2">
    <p class="text-h4">
      <slot name="hint"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'SelectField',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    icon: {
      type: Object,
      default: () => {
        return { side: null, class: null }
      }
    },
    placeholder: {
      type: String,
      default: null
    },
    filled: {
      type: Boolean,
      default: false
    },
    borderColor: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    iconClassLeft: {
      type: String,
      default: ''
    },
    iconClassRight: {
      type: String,
      default: ''
    },
    valuePropName: {
      type: String,
      default: 'value'
    },
    titlePropName: {
      type: String,
      default: 'title'
    },
    isSimpleDesign: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change', 'on-left-click', 'on-right-click', 'update:modelValue'],
  computed: {
    isOnlyObjectOptions() {
      return typeof this.options[0] === 'object'
    }
  },
  methods: {
    selectValue(e) {
      this.$emit('update:modelValue', e.target.value)
    }
  }
}
</script>

<style lang="scss">
.select-field {
  position: relative;
  max-width: 100%;
  background-color: var(--color-secondary);
  border-radius: rem(16);
  border: 2px solid var(--color-primary);

  &--focus {
    border-color: var(--color-brand-purple);
  }
  &--filled {
    border-color: transparent;
    background-color: var(--color-gray-6);
  }

  &__icon {
    pointer-events: none;
    position: absolute;
    transform: translateY(-50%);
    top: 50%;

    &--right {
      right: rem(18);
    }
  }

  &__select {
    border-radius: rem(16);
    font-size: rem(16);
    line-height: rem(24);
    height: rem(52);
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    outline: none;
    -webkit-appearance: none;
    appearance: none;
    margin-right: rem(48);
    color: var(--color-gray-4);

    option {
      color: var(--color-primary);
    }

    &-wrapper {
      position: relative;
      width: 100%;
    }

    &--has-icon-left {
      // padding-left: rem(48);
    }

    &--has-icon-right {
      // padding-right: rem(48);
    }

    &[disabled] {
      // @apply border-gray-1;
      // @apply text-gray-1;

      ~ .select-field__icon {
        // @apply text-gray-1;
      }
    }
  }

  &--simple {
    border-radius: var(--grid-8);
    border: 2px solid var(--color-primary);

    .select-field__select {
      height: var(--grid-32);
    }
  }

  &--error {
    border-color: var(--color-brand-red) !important;
    .select-field__select {
    }

    .select-field__msg {
      // @apply text-brand-red;
    }
  }
}
</style>
